var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProlificLibraryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.311,
    height: 61.311,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141656",
    fill: "none",
    d: "M0 0h61.311v61.311H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141651",
    fill: "none",
    d: "M0 0h8.386v12.013H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141653",
    fill: "none",
    d: "M0 0h12.013v8.386H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38723"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38722",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38721"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38720",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 141649",
    width: 54.022,
    height: 54.022,
    rx: 6,
    transform: "translate(3.644 3.644)",
    fill: "none",
    stroke: "#c3cbd7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47812",
    d: "M44.863 34.301v9.74c0 1.2-.532 1.739-1.727 1.739h-9.2c.362.362.641.652.931.94s.6.6.893.893a1.453 1.453 0 0 1 .011 2.054l-.011.01a1.421 1.421 0 0 1-2.009-.006l-.017-.018a480.9 480.9 0 0 1-4.358-4.334 1.4 1.4 0 0 1-.052-1.98c.028-.029.058-.058.088-.085 1.413-1.425 2.837-2.835 4.248-4.248a1.447 1.447 0 1 1 2.027 2.053c-.566.578-1.146 1.135-1.787 1.775h8.051v-8.4c-.036-.024-.06-.048-.1-.072-.542.568-1.075 1.158-1.653 1.689a2 2 0 0 1-.88.494 1.347 1.347 0 0 1-1.508-.736 1.457 1.457 0 0 1 .242-1.679c.156-.168.314-.326.47-.482 1.269-1.267 2.523-2.535 3.79-3.814a1.444 1.444 0 0 1 2.2-.012l4.152 4.152a1.451 1.451 0 1 1-2.027 2.053c-.567-.516-1.121-1.07-1.774-1.723",
    fill: "#2d3e5c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47813",
    d: "M25.603 46.783a10.3 10.3 0 0 0-14.555-.583q-.3.28-.583.583a.907.907 0 0 0-.234.6v3.6a.9.9 0 0 0 .9.888h13.806a.9.9 0 0 0 .9-.9v-3.6a.906.906 0 0 0-.234-.588",
    fill: "#dc1e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6025",
    cx: 4.202,
    cy: 4.202,
    r: 4.202,
    transform: "translate(13.833 33.866)",
    fill: "#2d3e5c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47814",
    d: "M51.59 22.399a10.3 10.3 0 0 0-14.555-.583q-.3.28-.583.583a.907.907 0 0 0-.234.6v3.6a.9.9 0 0 0 .9.888h13.805a.9.9 0 0 0 .9-.9v-3.6a.906.906 0 0 0-.234-.588",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47815",
    d: "M48.226 13.685a4.2 4.2 0 1 1-4.2-4.2 4.2 4.2 0 0 1 4.2 4.2",
    fill: "#2d3e5c"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38716",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38715"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38714",
    clipPath: "url(#b)",
    transform: "translate(14.009 19.589)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141650",
    fill: "#ff5d48",
    d: "M0 0h8.386v12.013H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38719",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38718"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38717",
    clipPath: "url(#c)",
    transform: "translate(23.982 9.616)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141652",
    fill: "#5ed142",
    d: "M0 0h12.013v8.386H0z"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141654",
    fill: "#ffdb4d",
    d: "M14.009 9.616h8.386v8.386h-8.386z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProlificLibraryIcon);
export default __webpack_public_path__ + "static/media/prolific_libraryIcon.9a9f72bcd1dba01472a36b6d1c55e6e3.svg";
export { ForwardRef as ReactComponent };